import React from 'react'

import SvgResume from '../../images/svg/SvgResume'

export default function DownloadResume() {
    return(
        <div>
            <a target="_blank" href="./resume.pdf">
                <SvgResume />
            </a>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/containers/navigation/DownloadResume.jsx